import { PageLayout } from '@/components/layouts/PageLayout.tsx'
import { useAuth } from '@/hooks/useAuth.ts'
import React from 'react'
import { Typography } from 'antd'
import Title from 'antd/es/typography/Title'

export const HomePage: React.FC = () => {
  const { user } = useAuth()

  return (
    <PageLayout>
      <Typography>
        <Title level={4}>
          Hi {user?.name}, welcome to finance portal
        </Title>
      </Typography>
    </PageLayout>
  )
}